<script setup lang="ts">
import hljs from 'highlight.js/lib/core'
import json from 'highlight.js/lib/languages/json'
import 'highlight.js/styles/intellij-light.min.css'
import './assets/style.scss'
import { computed, type PropType } from 'vue'

const props = defineProps({
  lang: {
    type: String,
    default: 'json',
  },
  code: {
    type: Object as PropType<object | null>,
    required: true,
  },
})

hljs.registerLanguage('json', json)

const result = computed(() => {
  if (!props.code) return

  let code: object | string = props.code

  if (props.lang === 'json') {
    code = JSON.stringify(code, null, 3)
  }

  return hljs.highlight(code as string, { language: 'json' }).value
})
</script>

<template>
  <div class="v-highlight">
    <pre v-if="code"><code v-html="result"></code></pre>

    <div v-else class="v-highlight__empty">{{ $t('itf.not_info') }}</div>
  </div>
</template>
